import { hours as Hours } from '@harvesthq/clockwork'

import moment from 'moment'
import {
  forwardRef,
  useEffect,
  useRef,
  useState,
  useImperativeHandle,
} from 'preact/compat'

import { toDuration, formattedTime } from '../lib/helpers/time'

const DurationInputComponent = ({ onChange }, ref) => {
  const durationInput = useRef(null)
  const [duration, setDuration] = useState()

  const clear = () => {
    if (durationInput.current) durationInput.current.value = ''
    setDuration(undefined)
  }

  useImperativeHandle(ref, () => ({
    clear,
  }))

  const onEnterTime = () => {
    if (durationInput.current) {
      setDuration(toDuration(Hours.to_decimal(durationInput.current.value)))
    }
  }

  useEffect(() => {
    if (duration) {
      const formattedDuration = formattedTime(
        moment.duration(duration).asHours()
      )
      onChange(formattedDuration)
    } else {
      onChange()
    }
  }, [duration, onChange])

  const sanitizeInput = () => {
    const input = durationInput.current

    if (!input) return

    if (duration) {
      input.value = formattedTime(moment.duration(duration).asHours())
    } else {
      input.value = ''
    }
  }

  return (
    <div>
      <input
        type="text"
        className="pds-input input-duration pds-mb-sm pds-ml-sm"
        placeholder={Hours.localize(0)}
        ref={durationInput}
        onKeyUp={onEnterTime}
        onBlur={sanitizeInput}
      />
    </div>
  )
}

export const DurationInput = forwardRef(DurationInputComponent)
